export enum CoreStatus
{
   Inactive,
   ParserLearning,
   ParserLearningFinished,
   DetectorLearning,
   DetectorLearningFinished,
   Working
}